<template lang="pug">
  .consultation--location
    .location-header.d-flex.align-center.primary--text.pt-5.pb-3
      h4(v-if="isLocation") Standort {{ locationName }}
      h4(v-else) Unternehmen allgemein

      a.d-flex.ml-3(v-if="panel && panel.length" @click="panel = []"): svg-reload(:size="18")

    v-expansion-panels(v-model="panel" accordion flat tile multiple)
      v-expansion-panel.mb-3(v-for="c in categories" :key="c.name")
        v-expansion-panel-header.category-header.pr-4
          .d-flex.align-center
            span {{ c.name }}
            svg-warning.svg-right-aligned.ml-5(v-if="c.has_empty && showEmptyNotice" :size="18")

            n-error-tooltip.error-info.ml-5(
              v-if="c.errorFields && c.errorFields.length"
              :title="`Folgende Felder müssen einen Wert beinhalten:`"
              :info-text="getErrorFieldNames(c.errorFields)"
            )

        v-expansion-panel-content(eager)
          category-basis(
            v-if="isBasis"
            :fields="c.fields"
            :buildings="c.buildings"
            @add-group="(id) => $emit('add-group', id)"
            @del-group="(field_id, id) => $emit('del-group', field_id, id)"
            @update="(id, v) => $emit('update', id, v)"
            @open-field="onOpenField"
          )

          category(
            v-else
            :fields="c.fields"
            :buildings="c.buildings"
            @add-group="(id) => $emit('add-group', id)"
            @del-group="(field_id, id) => $emit('del-group', field_id, id)"
            @update="(id, v) => $emit('update', id, v)"
            @open-field="onOpenField"
          )

</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

import FormMixin from '@/mixins/form'

@Component({
  mixins: [
    FormMixin
  ],

  components: {
    Category: () => import('./category'),
    CategoryBasis: () => import('./category-basis'),
    SvgWarning: () => import('@/components/svgs/svg-warning'),
    SvgReload: () => import('@/components/svgs/svg-reload'),
  },

  computed: mapGetters([
    'isBasis'
  ]),
})
export default class Location extends Vue {
  @Prop({ type: Array, default: () => [] }) categories
  @Prop({ type: Boolean, default: false }) isLocation
  @Prop({ type: String, default: '' }) locationName

  panel = [0]

  mounted () {
    this.panel = [0]
  }

  getErrorFieldNames (fields) {
    if (!fields || !fields.length) {
      return ''
    }

    return fields
      .map(f => {
        return f.building
          ? `${ f.name } <b>(${ f.building })</b>`
          : f.name
      })
      .join('\n')
  }

  openPanel (field, index) {
    if (field.hidden) {
      return
    }

    this.panel.push(index)
    this.panel = [
      ...this.panel
    ]

    setTimeout(() => {
      this.scrollToField(field.id)
    }, 300)
  }

  onOpenField (id) {
    const found = this.searchFieldInCategory(id, this.categories, this.openPanel)

    if (!found) {
      // console.log('need to find in another location')
      this.$emit('open-field', id)
    }
  }
}
</script>

<style lang="scss">
.consultation--location {
  .error-info {
    text-align: right;
  }
}
</style>
